module.exports = __webpack_public_path__ + "static/img/10043.9adc1ade.png";